export const createHash = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const truncate = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
};

export const compareDates = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const dateOnly1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const dateOnly2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());

  return dateOnly1.getTime() === dateOnly2.getTime();
};

export const formatUnixDate = (unixDate, time = false) => {
  const date = new Date(unixDate * 1000);

  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };

  const formatter = new Intl.DateTimeFormat(
    'en-US',
    time ? { ...options, hour: 'numeric', minute: '2-digit', hour12: true } : options,
  );
  return formatter.format(date);
};

export const formatNumberWithCommas = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
